








































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/Auth/AppModule';
import { RegionsModule } from '@/store/Settings/RegionsModule';

@Component({ name: 'HolidaysWidget' })
export default class extends Vue {

    async beforeMount() {
        await RegionsModule.getUpcomingPublicHolidays(3);
    }

    get loading() {
        return RegionsModule.loadingUpcomingPublicHolidays;
    }

    get publicHolidays() {
        return RegionsModule.upcomingPublicHolidays;
    }

    async openDocs(url: string) {
        await AppModule.openExternalDocumentationURL(url);
    }

}
